module.exports = __webpack_public_path__ + "img/lens-167-minus-10.9fa8ad54.png";